import {
   IAreaCode,
   IPhoneNumberOption,
} from '@forwardflow/features/campaign-flow/interfaces/campaign-flow.types'

/**
 * The area codes a campaign starts with: every code holding at least 15% of
 * the leads, at most three; at least the busiest one. `codes` arrive busiest
 * first.
 */
export const suggestedCodes = (codes: IAreaCode[]): IAreaCode[] => {
   const big = codes.filter((c) => c.leadShare >= 15).slice(0, 3)
   return big.length ? big : codes.slice(0, 1)
}

/**
 * A spare number the organization already owns in that area code (not in
 * `taken`), else the first one for sale there.
 */
export const numberForCode = (
   code: string,
   owned: IPhoneNumberOption[],
   taken: IPhoneNumberOption[],
   forSale: IPhoneNumberOption[] = []
): IPhoneNumberOption | undefined =>
   owned.find(
      (n) => n.areaCode === code && !taken.some((t) => t.number === n.number)
   ) ?? forSale.find((n) => n.areaCode === code)

/** A number's area code and the number list without it, for toggling by code. */
export const inCode = (list: IPhoneNumberOption[], code: string) =>
   list.filter((n) => n.areaCode === code)
